module.exports = __webpack_public_path__ + "static/media/d4.c8e13cfe.jpg";